<template>
  <Header />
    <div class="container-fluid">
        <!-- APP DOWNLOAD CTA BANNER -->
        <div class="row mb-2">
            <div class="col-lg-2 col-md-2 col-sm-2"></div>
            <div class="col-lg-8 col-md-8 col-sm-8">
                <div class="app-download-banner">
                    <div class="banner-left">
                        <span class="banner-badge">গুরুত্বপূর্ণ নোটিশ</span>
                        <h4 class="banner-title">প্যাকেজটি অ্যাক্সেস করতে অ্যাপ ডাউনলোড করুন</h4>
                        <p class="banner-subtitle">আপনার কেনা প্যাকেজের সকল পরীক্ষা, কুইজ ও লেকচার নোট শুধুমাত্র আমাদের অ্যান্ড্রয়েড অ্যাপে উপলব্ধ। এখনই অফিশিয়াল অ্যাপটি ইনস্টল করুন।</p>
                    </div>
                    <div class="banner-right">
                        <a href="https://play.google.com/store/apps/details?id=com.bcsprostuti.tanim.bcsprostuti" target="_blank" class="play-store-btn" @click="trackAppDownload">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" height="42">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2"></div>
        </div>

        <div class="container-fluid pl-0 pr-0">
            <div v-if="purchaseHistory" class="rank-list">
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-2" ></div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                        <table class="leader-board-participants table table-responsive-md text-center">
                            <thead>
                            <th colspan="2"> <h5>ট্রানজেকশন হিস্টরি</h5></th>
                            </thead>
                            <tbody>
                            <tr  v-for="(item, index) in purchaseHistory" :key="index">
                                <td class="text-left">
                                    <span class="username">{{ item.package_name }}</span><br>
                                    <span><small>ট্রান. আইডি: {{ item.tran_id }} </small></span>
                                </td>
                                <td class="text-right" >
                                    <span> {{ item.tran_date }} </span><br>
                                    <span> ৳{{ item.taka }} </span><br>
                                    <span> {{ item.status }} </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2" ></div>
                </div>
            </div>
        </div>

        <div style="padding-top: 40px">
        </div>
        <div ref="footer">
            <Footer />
        </div>
    </div>
</template>
  
<script>
// import Header from "@/components/HeaderView.vue";
import Header from "@/components/NewHeaderView.vue";
import Footer from "@/components/FooterView.vue";
import { onMounted, ref } from 'vue'
import Swal from 'sweetalert2/dist/sweetalert2';
import httpClient from "@/config/httpClient";
import { StaticTags } from "@/static";
import { fbPixel, gaEvent } from "@/config/pixels";

export default {
    components: {
        Footer,
        Header,
    },

    setup() {

        const purchaseHistory = ref(null)
        onMounted(() => {
            getPurchaseHistory()
        })

        const getPurchaseHistory = async () => {
            await httpClient
                .get(process.env.VUE_APP_API_BASE_URL + "/memberships/lendens")
                .then((res) => {
                    if (res.success) {
                        
                        purchaseHistory.value = res.lendens
                    }
                    else {
                        Swal.fire({
                            text: res.message,
                            title: "Failed",
                            icon: StaticTags.ALERT_TYPE_ERROR
                        })
                    }


                })
        }
        const trackAppDownload = () => {
            fbPixel('Lead', {
                content_name: 'App Download Purchase Confirmation',
                content_category: 'BCS App'
            });
            gaEvent('app_download_click', {
                event_category: 'engagement',
                event_label: 'purchase_history_banner'
            });
        }

        return {
            purchaseHistory,
            trackAppDownload,
        }
    }
}
</script>
  
<style>
.first {
    color: green;
}

.second {
    color: blue;
}

.third {
    color: orange;
}

.rank-list {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
    padding: 1rem;
}

.card {
    border: 1px solid #ccc;
    border-radius: 0.25rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-title {
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
    font-weight: bold;
}

.card-text {
    margin-bottom: 0.25rem;
    font-size: 1rem;
}

.leader-board-participants {
    margin: 20px 0 0 0;
    padding-left: 10px;
    padding-bottom: 10px;
}

.leader-board-participants tr {
    border-radius: 20px;
    padding: 5px 20px 5px 5px;
    margin-bottom: 10px;
    position: relative;
    background: #f1f1f1;
}

.leader-board-participants tr .username {
    display: inline-block;
    vertical-align: sub;
}
.leader-board-participants tr:nth-child(even) {
    background: whitesmoke;
    color: black;
}

.leader-board-participants tr:nth-child(odd) {
    background: white;
    color: #0a0a0a;
}

/* APP DOWNLOAD CTA BANNER STYLES */
.app-download-banner {
  background: linear-gradient(135deg, #191B47 0%, #312e81 100%);
  border-radius: 16px;
  padding: 24px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 20px rgba(25, 27, 71, 0.15);
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 20px;
  text-align: left;
}

.banner-left {
  flex: 1;
  min-width: 250px;
}

.banner-badge {
  display: inline-block;
  background: rgba(245, 158, 11, 0.15);
  border: 1px solid rgba(245, 158, 11, 0.4);
  color: #F59E0B;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
  margin-bottom: 10px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.banner-title {
  font-family: 'Noto Sans Bengali', system-ui, -apple-system, sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: #ffffff;
}

.banner-subtitle {
  font-size: 0.88rem;
  color: #cbd5e1;
  margin: 0;
  line-height: 1.5;
}

.banner-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.play-store-btn {
  display: inline-flex;
  transition: transform 0.2s;
}

.play-store-btn:hover {
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .app-download-banner {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }
  .banner-right {
    width: 100%;
    justify-content: center;
  }
}
</style>
  